// BackBtn.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';

const BackBtn = ({ fixed = false }) => {
  const navigate = useNavigate();

  return (
    <div
      style={{
        position: fixed ? 'fixed' : 'absolute',
        top: '20px',
        left: '20px',
        zIndex: 2000,
      }}
    >
      <button
        onClick={() => navigate(-1)}
        style={{
          padding: '0.5rem 0.7rem',
          fontSize: '1.2rem',
          fontWeight:'bold',
          backgroundColor: '#F37021',
          color: '#fff',
          border: 'none',
          borderRadius: '0.5rem',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
        }}
      >
        <FaArrowLeft />
      </button>
    </div>
  );
};

export default BackBtn;
